export const myPage_sv = {
  'edit_profile' : 'Redigera profil',
  'walks' : 'Promenader',
  'messages' : 'Meddelande',
  'contacts' : 'Kontakter',
  'current_week' : 'Nuvarande vecka',
  'organiser' : 'Organisatör',
  'not_booked' : 'Obokad',
  'active_conversations' : 'Aktiva konversationer',
  'archived_conversations' : 'Arkiverade konversationer',
  'friends' : 'Vänner',
  'add_friends_with_email' : 'Lägg till vänner',
  'search_email' : 'Eller sök med email',
  'search_person_button' : 'Sök',
  'search_result' : 'Sökresultat',
  'send_friendrequest_to' : 'Bli vän ',
  'go_to' : 'Gå till ',
  'go_to_profile' : ' profil',
  'search_person_name' : 'Sök med förnamn',

  'no_email_error' : 'Fyll i en adress för att söka',
  'cannot_find_email_error' : 'Kan inte hitta ',
  'cannot_send_self' : 'Du kan inte skicka en vänförfrågan till dig själv.',
  'sent_confirmation_header' : 'Skickad',
  'sent_confirmation_message' : 'Vänförfrågan är skickad till',
  'add_more_friends' : 'Lägg till fler',

  'calendar' : 'Kalender',

  'available_walks' : 'Tillgängliga promenader',
  'share_profile' : 'Dela profilen',
  'share_your_profile' : 'Dela din profil',

  'settings' : 'Inställningar',
  'account_settings' : 'Kontoinställningar',
  'handle_blocked' : 'Hantera blockerade',
  'send_feedback' : 'Skicka feedback',
  'upgrade_to_pro' : 'Walking Talking PRO',

  'feedback' : 'Feedback',
  'send_feedback_message' : 'Vi välkomnar alla frågor och synpunkter och även om vi inte svarar på allt, tar vi det med oss i vår utveckling för att göra Walking Talking bättre.',
  'feedback_placeholder' : 'Skriv din feedback här',
  'feedback_GDPR' : 'Jag godkänner att ni kontaktar mig om ni vill veta mer om min feedback.',
  'change_saved' : 'Ändringen är sparad',
  'something_went_wrong' : 'Någonting gick snett',
  'upgrade_WT_PRO' : 'Uppgradera till Walking Talking PRO nu',

  'archive_chat_with' : 'Arkivera chatten med ',
  'activate_chat_with' : 'Aktivera chatten med ',
  'has_sent_friendrequest' : ' har skickat en vänförfrågan. Vill du:',
  'walk_suggestion' : 'Promenad förslag',
  'has_booked' : ' har bokat promenaden:',
  'booked_confirmation' : 'Promenaden har bokats',
  'cancel_confirmation' : 'Promenaden har ställts in',
  'conversation_archived' : 'Konversationen är arkiverad',

  'change_language_error' : 'Kunde inte ändra språket, försök igen eller kontakta Walking Talking om problemet kvartstår.`',
  'biography_placeholder' : 'Skriv något kort',

  'feedback_confirmation' : 'Tack för din feedback!',
  'owner_contacts' : 's kontakter',
  'owner_calendar' : 's kalender',
  'send_message' : 'Chatta',

  'invited' : 'Inbjuden',
  'guest' : 'Gäst',
  'not_public' : 'Inte offentlig',

  'no_walks_today' : 'Inga promenader denna dag',
  'find_friends' : 'Hitta vänner',
  'suggestion_sent' : 'Promenad förslaget är skickat',
  'persons_found' : 'personer hittades',
  'become_friend' : 'Bli vän',
  'current_walk' : 'Nuvarande promenad',
  'view_walks' : 'Se promenader',
  'track_walks' : 'Hantera föregående och kommande promenader',
  'statistic' : 'Statistik',
  'statistic_info' : 'Utmaningar, statistik, dagliga steg & mål',
  'view_statistic' : 'Se statistik',
  'stepchallenges' : 'Steg-utmaningar',
  'manage_friends' : 'Hitta, hantera & skaffa nya vänner',
  'view_friends' : 'Se vänlista',
  'find_new_friends' : 'Hitta nya vänner',
  'friends_info' : 'Se, möt andra och hitta promenader i dina nätverk',
  'find_network' : 'Hitta nätverk',

}